export const FETCH_PROGRAMS_SUCCESS = 'FETCH_PROGRAMS_SUCCESS';
export const FETCH_PROGRAMS_REQUEST = 'FETCH_PROGRAMS_REQUEST';
export const FETCH_PROGRAMS_FAILURE = 'FETCH_PROGRAMS_FAILURE';